import { useDispatch, useSelector } from 'react-redux';
import { Button, generateResolver, Modal, Notification, STATUS_TYPES, VALIDATORS } from 'dyl-components';
import React, { useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { Form } from 'semantic-ui-react'
import productsActions from 'actions/products';
import { StringUtils } from 'utils';
import FullScreenModalPopUp from 'shared/FullScreenModalPopUp';

export default function NewNumberPopup({ type, open, onClose, subscription_id, onReload }) {
    const dispatch = useDispatch();
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const { control, formState: { isValid, isDirty }, reset, watch, handleSubmit } = useForm({
        mode: 'onChange',
        defaultValues: {
            new_number: '',
            phone_number: ''
        },
        resolver: generateResolver({
            phone_number: VALIDATORS.PHONE_NUMBER().required('This field is required')
        })
    });
    const isAssigningNumber = useSelector(state => state.products.isAssigningNumber);
    const onSubmit = async (data) => {
        try {
            const { phone_number } = data
            await dispatch(productsActions.assignNumber(subscription_id, {
                phone: phone_number,
                carrier: "bandwidth",
                secure: false
            }))
            Notification.alert('Number assigned successfully', STATUS_TYPES.SUCCESS)
            reset({})
            onClose()
            onReload()
        } catch (error) {
            console.error(error);
            Notification.alert('Failed to assign number', STATUS_TYPES.ERROR)
        }
    }
    const getHeaderName = (type) => {
        switch (type) {
            case "local_number":
                return "New Local Number";
            case "port_in_local_number":
                return "Port Local Number";
            case "toll_free_number":
                return "New Toll-Free Number";
            case "port_in_toll_free_number":
                return "Port Toll-Free Number";
            default:
                return StringUtils.capitalize(type);
        }
    }
    return (
        <React.Fragment>
            <Modal open={open} onClose={onClose} size={!watch('new_number') ? 'tiny' : ''} >
                <React.Fragment>
                    <Modal.Header>
                        {getHeaderName(type)}
                    </Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Group>
                                <Controller
                                    name='new_number'
                                    control={control}
                                    render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                                        <Form.Select
                                            name={name}
                                            label='New Number'
                                            required
                                            width={8}
                                            value={value}
                                            onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                            placeholder='Select'
                                            selectOnBlur={false}
                                            options={[{
                                                key: "new_number",
                                                value: "new_number",
                                                text: "Enter Purchased Number"
                                            }]}
                                            disabled={isAssigningNumber}
                                        />
                                    )}
                                />
                                {watch("new_number") === "new_number" && <Controller
                                    name='phone_number'
                                    control={control}
                                    render={({ field: { onChange, value, name }, fieldState: { error } }) => (
                                        <Form.Input
                                            label='Enter Phone Number'
                                            required
                                            width={8}
                                            placeholder='Enter Phone Number'
                                            name={name}
                                            value={value}
                                            error={error && error.message}
                                            onChange={(_, { value }) => { onChange({ target: { name, value } }) }}
                                            disabled={isAssigningNumber}
                                        />
                                    )}
                                />}
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => {
                            setIsConfirmationModalOpen(true)
                        }} disabled={!isValid || !isDirty || isAssigningNumber} loading={isAssigningNumber} primary>Save</Button>
                    </Modal.Actions>
                </React.Fragment>
            </Modal>
            <FullScreenModalPopUp
                header={"Are you sure?"}
                isOpen={isConfirmationModalOpen}
                onConfirm={() => {
                    setIsConfirmationModalOpen(false)
                    handleSubmit(onSubmit)();
                }}
                topPadded={true}
                closeIcon={false}
                onFormClose={() => {
                    setIsConfirmationModalOpen(false)
                }}
            />
        </React.Fragment>
    )
}
